import Elon from "../images/Elon.jpg";
import AlienWorlds from "../images/AlienWorlds.jpg";
import Cibi from "../images/Cibi.jpg";
import KuCoin from "../images/KuCoin.jpg";
import KuCoinDiscription from "../images/KuCoinDiscription.jpg";

var Tweets = [
  {
    name: "Elon Musk",
    username: "@elonmusk",
    date: "Jan 4",
    discription: "Tesla merch buyable with Dogecoin",
    likes: "300.4K",
    comments: "33.3K",
    retweets: "58.5K",
    retweetName: "The Bearble Bull Retweeted",
    profilePic: Elon,
    verified: true
  },
  {
    name: "KU Coin",
    username: "@kucoin",
    date: "Feb 5",
    discription:
      "Whats the next biggest trend in #Crypto,Whats the next biggest trend in #Crypto",
    likes: "300K",
    comments: "20.2K",
    retweets: "20.7K",
    profilePic: KuCoin,
    disImage: KuCoinDiscription
  },
  {
    name: "AlienWorlds",
    username: "@AlienWorlds",
    date: "Oct 27",
    discription:
      "Hello Explorers, new Alien Worlds Missions Game on the Binance Smart Chain (BSC) is now live! Prepare for launch! https://play.alienworlds.io",
    likes: "300K",
    comments: "20.2K",
    retweets: "20.7K",
    profilePic: AlienWorlds
  },
  {
    name: "Cibi Chakaravarthi",
    username: "@Dir_Cibi",
    date: "May 21, 2022",
    discription: "Verified ☑️ Thank you @verified @TwitterIndia 😇 @ragulparasuram 👍",
    likes: "8000K",
    comments: "43K",
    retweets: "981K",
    profilePic: Cibi,
    verified: true
  },
  {
    name: "KU Coin",
    username: "@kucoin",
    date: "Feb 5",
    discription:
      "Whats the next biggest trend in #Crypto,Whats the next biggest trend in #Crypto",
    likes: "300K",
    comments: "20.2K",
    retweets: "20.7K",
    retweetName: "Karan Blazer Retweeted",
    profilePic: AlienWorlds
  }
];



export default Tweets ;
